import { styled } from "styled-components";

import { MainLayout } from "common/components";
import { breakpoints, mediaStyles } from "common/styles";
import { ContentBody } from "domains/termsAndConditions/components/ContentBody";
import { TableOfContents } from "domains/termsAndConditions/components/TableOfContents";
import type { TOCType } from "domains/termsAndConditions/types";
import { useTermsAndConditionsData } from "domains/termsAndConditions/useTermsAndConditionsData";

const StyledContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.backgroundPrimary};
`;

const StyledContent = styled.div`
  box-sizing: border-box;
  margin-top: 1rem;

  ${mediaStyles(({ spacing }) => `padding: 0 ${spacing}rem ${spacing}rem ${spacing}rem;`)};

  @media ${breakpoints.large} {
    margin-top: 2rem;
  }

  @media ${breakpoints.extraLarge} {
    padding: 3rem;
    margin-top: 0;
  }
`;

const StyledTopBar = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 2rem;

  @media ${breakpoints.extraLarge} {
    display: none;
  }
`;

type TermsAndConditionsProps = { type: TOCType };

const tabItems: TOCType[] = ["terms-and-conditions", "privacy-policy", "cookie-notice"];

export const TermsAndConditions = ({ type }: TermsAndConditionsProps) => {
  const data = useTermsAndConditionsData();

  const sidePanel = <TableOfContents tabs={tabItems.map((item) => data[item])} />;

  return (
    <StyledContainer>
      <MainLayout sidePanel={sidePanel}>
        <StyledContent>
          <StyledTopBar>{sidePanel}</StyledTopBar>
          <ContentBody tab={data[type]} />
        </StyledContent>
      </MainLayout>
    </StyledContainer>
  );
};
